import React from 'react';
import { observer } from 'mobx-react-lite';
import {
    PopupWrapper,
    CloseIconWrapper,
    PopupLabel,
    PopupText,
} from 'src/domains/layouts/shared/popup/popups/cms/Popup.style';
import { Button } from 'src/domains/layouts/shared/buttons/Button';

interface DeletePopupPropsType {
    handleDelete: () => void;
    handleHidePopup: () => void;
}

export const DeletePopup = observer(({ handleDelete, handleHidePopup }: DeletePopupPropsType) => {
    return (
        <PopupWrapper>
            <CloseIconWrapper onClick={handleHidePopup} />
            <PopupLabel>Are you sure you want to delete this item?</PopupLabel>
            <PopupText>You can&apos;t undo this action.</PopupText>
            <Button
                size='big'
                status='delete'
                onClick={handleDelete}
                dataTest='delete-popup'
            >
                Delete
            </Button>
            <Button
                size='big'
                version='secondary'
                onClick={handleHidePopup}
                dataTest='cancel-popup'
            >
                Cancel
            </Button>
        </PopupWrapper>
    );
});
